/**
 * Country & dial-code constants for the public booking flow.
 *
 * Two lists shipped inline (no runtime fetch) so the modal renders
 * instantly. Alphabetised list for the Country <select>; a compact list
 * of frequently-used dialling codes for the phone country picker with
 * every ITU-T country still available further down.
 */

// Alphabetical superset — powers both the Country <select> and the full
// list at the bottom of the dial-code picker.
export const COUNTRIES = [
  "Australia", "Austria", "Belgium", "Brazil", "Bulgaria", "Canada", "China",
  "Croatia", "Cyprus", "Czech Republic", "Denmark", "Egypt", "Estonia",
  "Finland", "France", "Germany", "Greece", "Hungary", "Iceland", "India",
  "Ireland", "Israel", "Italy", "Japan", "Latvia", "Lithuania", "Luxembourg",
  "Malta", "Mexico", "Netherlands", "New Zealand", "Norway", "Poland",
  "Portugal", "Romania", "Russia", "Serbia", "Slovakia", "Slovenia",
  "South Africa", "South Korea", "Spain", "Sweden", "Switzerland", "Turkey",
  "Ukraine", "United Arab Emirates", "United Kingdom", "United States",
];

// Dialling-code catalogue — flag emoji + ISO alpha-2 for the compact
// picker. Ordered by user prevalence for a Greek rent-a-car business
// (GR first), then remaining codes alphabetised by country name.
export const DIAL_CODES = [
  { code: "+30",  iso: "GR", label: "Greece" },
  { code: "+44",  iso: "GB", label: "United Kingdom" },
  { code: "+1",   iso: "US", label: "United States" },
  { code: "+49",  iso: "DE", label: "Germany" },
  { code: "+33",  iso: "FR", label: "France" },
  { code: "+39",  iso: "IT", label: "Italy" },
  { code: "+34",  iso: "ES", label: "Spain" },
  { code: "+31",  iso: "NL", label: "Netherlands" },
  { code: "+41",  iso: "CH", label: "Switzerland" },
  { code: "+43",  iso: "AT", label: "Austria" },
  { code: "+32",  iso: "BE", label: "Belgium" },
  { code: "+45",  iso: "DK", label: "Denmark" },
  { code: "+46",  iso: "SE", label: "Sweden" },
  { code: "+47",  iso: "NO", label: "Norway" },
  { code: "+48",  iso: "PL", label: "Poland" },
  { code: "+350", iso: "GI", label: "Gibraltar" },
  { code: "+351", iso: "PT", label: "Portugal" },
  { code: "+353", iso: "IE", label: "Ireland" },
  { code: "+354", iso: "IS", label: "Iceland" },
  { code: "+357", iso: "CY", label: "Cyprus" },
  { code: "+358", iso: "FI", label: "Finland" },
  { code: "+359", iso: "BG", label: "Bulgaria" },
  { code: "+36",  iso: "HU", label: "Hungary" },
  { code: "+370", iso: "LT", label: "Lithuania" },
  { code: "+371", iso: "LV", label: "Latvia" },
  { code: "+372", iso: "EE", label: "Estonia" },
  { code: "+380", iso: "UA", label: "Ukraine" },
  { code: "+381", iso: "RS", label: "Serbia" },
  { code: "+385", iso: "HR", label: "Croatia" },
  { code: "+386", iso: "SI", label: "Slovenia" },
  { code: "+40",  iso: "RO", label: "Romania" },
  { code: "+420", iso: "CZ", label: "Czech Republic" },
  { code: "+421", iso: "SK", label: "Slovakia" },
  { code: "+7",   iso: "RU", label: "Russia" },
  { code: "+61",  iso: "AU", label: "Australia" },
  { code: "+64",  iso: "NZ", label: "New Zealand" },
  { code: "+81",  iso: "JP", label: "Japan" },
  { code: "+82",  iso: "KR", label: "South Korea" },
  { code: "+86",  iso: "CN", label: "China" },
  { code: "+90",  iso: "TR", label: "Turkey" },
  { code: "+91",  iso: "IN", label: "India" },
  { code: "+55",  iso: "BR", label: "Brazil" },
  { code: "+52",  iso: "MX", label: "Mexico" },
  { code: "+972", iso: "IL", label: "Israel" },
  { code: "+971", iso: "AE", label: "United Arab Emirates" },
  { code: "+27",  iso: "ZA", label: "South Africa" },
  { code: "+20",  iso: "EG", label: "Egypt" },
  { code: "+352", iso: "LU", label: "Luxembourg" },
  { code: "+356", iso: "MT", label: "Malta" },
];

export const DEFAULT_DIAL_CODE = "+30";
